import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="bg-white rounded-3xl p-10 shadow-sm border border-black/5 max-w-md w-full text-center animate-pop-in">
        <div className="w-16 h-16 rounded-3xl mx-auto bg-[#F2EFEA] flex items-center justify-center">
          <XCircle className="w-9 h-9 text-[#718096]" />
        </div>
        <h1 className="font-head font-extrabold text-2xl mt-5">Checkout cancelled</h1>
        <p className="text-muted-foreground mt-2">
          No worries — you haven't been charged. You can subscribe whenever you're ready.
        </p>
        <div className="flex gap-3 justify-center mt-7">
          <button
            onClick={() => navigate("/hub")}
            className="border border-black/10 font-semibold px-7 py-3.5 rounded-full hover:bg-black/5 transition-colors"
            data-testid="cancel-to-hub"
          >
            Back to programs
          </button>
          <button
            onClick={() => navigate("/subscribe")}
            className="bg-[#2D3748] text-white font-semibold px-7 py-3.5 rounded-full hover:-translate-y-0.5 transition-transform"
            data-testid="cancel-retry"
          >
            View subscription
          </button>
        </div>
      </div>
    </div>
  );
}
